import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "-10 -11 532 512"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M177 259h-58q5 68 48 113l38-66zm-10-143q-43 45-48 113h58l28-47zm168 143-28 47 38 66q43-45 48-113zm-55 61h-48l-42 72q31 20 66 20t66-20zM256 76q-35 0-66 20l42 72h48l42-72q-31-20-66-20m89 40-38 66 28 47h58q-5-68-48-113m-63 82h-52l-27 46 27 46h52l27-46zM453 90q-48-30-101-9 13 12 25 25 14 17 28 46h107q-19-38-59-62m-71 286q-4 4-5 6-21 25-49 41l40 57q29-52 14-104m-247 6q-1-2-5-6-15 52 14 104l40-57q-28-16-49-41M59 90q-40 24-59 62h107q14-28 28-46 12-13 25-25-53-21-101 9M256-32q-20 0-34 14t-14 34v38q24-8 48-8t48 8V16q0-20-14-34t-34-14"
    }, null, -1)
  ])))
}
export default { render: render }